<template lang="pug">
  div
    Input.form-item__input.-input-only-(
      :inputStyle="{'paddingLeft': '40px', 'width': '300px'}"
      v-model="search"
      placeholder="Поиск"
      @clear="clearSearch"
      @keyup="keyUp"
    )
      Icon.search__main-icon.position-absolute(icon="search-thin" :style="{'left': '10px'}")

</template>

<script>
export default {
  props: ['value'],
  data: () => ({
    search: ''
  }),
  watch: {
    value() {
      this.search = this.value;
    }
  },
  mounted() {
    this.search = this.value;
  },
  methods: {
    clearSearch() {
      this.$emit('params', '');
    },
    keyUp(e) {
      this.$emit('params', e.target.value);
    }
  }
};
</script>
